document.addEventListener('DOMContentLoaded', function () {
// Desktop Header Nav
    const headerNavDropdown = document.querySelectorAll('.header__nav-links-item.has-dropdown');
    const toggleClass = (element) => {
        if(element.classList.contains('active')){
            element.classList.remove('active')
        }else{
            element.classList.add('active')
        }
    }

    headerNavDropdown.forEach((dropdown) => {
        dropdown.addEventListener('mouseover', function(){

            headerNavDropdown.forEach(d => d.classList.remove('active'));

            dropdown.classList.add('active');
        });
        dropdown.addEventListener('mouseout', function(){
            dropdown.classList.remove('active');
        });
    });


// Flickity [Custom Sliders]
    const frSliders = document.querySelectorAll('.fr-slider');
    frSliders.forEach((slider) => {
        new Flickity(slider, {
            cellAlign: 'left',
            contain: true,
        });
    });



});

function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    let expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }
  
  function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i <ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }
  
  function setQuizCompletedAttributeToCart(quiz_completed_value) {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        attributes: {
          '_quiz_completed': quiz_completed_value
        }
      })
    })
    .then(response => response.json());
  }
  
  function addQuizCompletionToCart() {
    var quiz_completed = getCookie('quiz_completed');
    var quiz_completed_value = null;
    if (quiz_completed) {
      quiz_completed_value = 'yes';
    }
    setQuizCompletedAttributeToCart(quiz_completed_value);
  }
  
  document.addEventListener('quizKitResultsPageLoaded', function (e) {  
    setCookie('quiz_completed', 'yes', 7);
    setQuizCompletedAttributeToCart('yes');
  }, false);
  
  // Call the function when the cart changes
  document.addEventListener('rebuy:cart.add', addQuizCompletionToCart);
  

  function productItemAddtoCart(variant_id, qty) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        'Accept': 'application/json'
      },
      body: `quantity=${encodeURIComponent(qty)}&id=${encodeURIComponent(variant_id)}`
    })
    .then(function(response) {
      if (!response.ok) {
        return response.text().then(function(text) {
          throw new Error(text);
        });
      }
      return response.json();
    })
    .then(function(itemData) {
      theme.partials.Cart.updateAllHtml(function() {
        console.log(theme.partials.Cart.getHtml());
        var cartRoot = document.querySelector('.cart--root');
        if (cartRoot) {
          cartRoot.setAttribute('data-has-items', 'true');
        }
        var offCanvasTrigger = document.querySelector('[data-off-canvas--open="right-sidebar"]');
        if (offCanvasTrigger) {
          // Emulate jQuery .trigger('click')
          offCanvasTrigger.click();
        }
      });
      console.log('success', itemData);
    })
    .catch(function(error) {
      console.log(error.message);
    });
  }